export const formatVND = (n: number) =>
  new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND", maximumFractionDigits: 0 }).format(n);

export const formatNumber = (n: number) =>
  new Intl.NumberFormat("vi-VN").format(n);

export const formatTime = (iso: string) => {
  const d = new Date(iso);
  return d.toLocaleString("vi-VN", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" });
};

export const formatDate = (iso: string) => {
  const d = new Date(iso);
  return d.toLocaleDateString("vi-VN", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const paymentLabel = (t: string | null | undefined): string => {
  if (!t) return "—";
  const map: Record<string, string> = {
    CASH: "Tiền mặt",
    CARD: "Thẻ",
    OTHER: "Khác",
  };
  return map[t] || t;
};
